import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
var TenantService = /** @class */ (function (_super) {
    tslib_1.__extends(TenantService, _super);
    function TenantService(http) {
        var _this = _super.call(this, http, MapperService.tenantMap) || this;
        _this._endpoint = '/odata/Tenants';
        return _this;
    }
    TenantService.prototype.setActive = function (tenantIds, active) {
        var payload = JSON.stringify({
            tenantIds: tenantIds,
            active: active,
        });
        return this._http
            .post(this._endpoint + "/UiPath.Server.Configuration.OData.SetActive", payload);
    };
    return TenantService;
}(ODataService));
export { TenantService };
